"use server";
import { pool } from "@/db";
import { requireAdminPage } from "@/lib/auth";
import { revalidatePath } from "next/cache";
export async function sendFeedback(_previous: {error:string;success:boolean}, data: FormData) {
 const name=String(data.get("name")??"").trim();
 const contact=String(data.get("contact")??"").trim();
 const category=String(data.get("category")??"");
 const message=String(data.get("message")??"").trim();
 if (String(data.get("website")??"")) return {error:"",success:true};
 if(!contact || contact.length>250 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact))
  return {error:"Укажите корректный адрес электронной почты для ответа.",success:false};
 if(name.length>120 || contact.length>250 || message.length<5 || message.length>5000 || !["Пожелание","Уточнение","Жалоба"].includes(category))
  return {error:"Сообщение должно содержать от 5 до 5000 символов. Проверьте заполнение полей.",success:false};
 try {
  await pool.query("INSERT INTO public.feedback_messages(name,contact,category,message) VALUES($1,$2,$3,$4)",[name,contact,category,message]);
  revalidatePath("/admin/feedback");
  return {error:"",success:true};
 } catch { return {error:"Не удалось отправить обращение. Попробуйте ещё раз.",success:false}; }
}
export async function updateFeedback(data:FormData) {
 await requireAdminPage("/admin/feedback");
 const id=Number(data.get("id"));const status=String(data.get("status"));
 if(!Number.isSafeInteger(id) || id<1 || !["new","in_progress","closed"].includes(status)) return;
 await pool.query("UPDATE public.feedback_messages SET status=$1 WHERE id=$2",[status,id]);
 revalidatePath("/admin/feedback");
}
export async function deleteFeedback(data:FormData) {
 await requireAdminPage("/admin/feedback");
 const id=Number(data.get("id"));if(!Number.isSafeInteger(id)||id<1)return;
 await pool.query("DELETE FROM public.feedback_messages WHERE id=$1",[id]);
 revalidatePath("/admin/feedback");
}
